import { useMutation, useQueryClient } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'

/**
 * Poner el punto de la orden a mano.
 *
 * Se guarda con origen «manual», y eso no es una etiqueta: fn_radio_del_sitio
 * le da 80 m a un punto puesto por una persona —el radio más apretado de la
 * escala—. Arrastrar el punto aprieta la geocerca en el mismo gesto, sin que
 * haya que pedirlo aparte.
 */
export function useMoverPunto() {
  const clienteConsultas = useQueryClient()

  return useMutation({
    mutationFn: async (datos: { ordenId: string; latitud: number; longitud: number }) => {
      const { error } = await supabase.rpc('fn_ubicar_orden', {
        p_orden_id: datos.ordenId,
        p_latitud: datos.latitud,
        p_longitud: datos.longitud,
        p_origen: 'manual',
        p_precision: null,
        // Sin texto de Google: no lo dijo Google, lo puso una persona.
        p_texto: null,
      })

      if (error) throw new Error(mensajeDeError(error))
    },
    onSuccess: async () => {
      await Promise.all(
        [
          ['sitio-de-la-orden'],
          ['quien-puede'],
          ['ordenes-ubicadas'],
          ['ordenes-sin-ubicar'],
          ['mis-geocercas'],
        ].map((clave) => clienteConsultas.invalidateQueries({ queryKey: clave })),
      )
    },
  })
}
